import { render, staticRenderFns } from "./AlternatingBlock.vue?vue&type=template&id=2c5aacc0&"
import script from "./AlternatingBlock.vue?vue&type=script&lang=js&"
export * from "./AlternatingBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports